import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  introduction: {
    title: <FormattedMessage {...messages.introTitle} />,
    copy: <FormattedMessage {...messages.introCopy} />,
    button: <FormattedMessage {...messages.introButton} />,
    imageSrc: 'images/cover.png',
  },
  questions: [
    {
      id: 'q1',
      questionNumber: 1.1,
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q1Title} />,
      imageSrc: 'images/question1-new.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q2',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q2',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q2',
        },
      ],
    },
    {
      id: 'q2',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q2Title} />,
      imageSrc: 'images/question2-new.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q3',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q3',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q3',
        },
      ],
    },
    {
      id: 'q3',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q3Title} />,
      imageSrc: 'images/question3-new.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q4',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q4',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q4',
        },
      ],
    },
    {
      id: 'q4',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q4Title} />,
      imageSrc: 'images/question4-new.png',
      popUp: {
        popUpText: <FormattedMessage {...messages.q4PopUpTitle} />,
        popUpList: [
          <FormattedMessage {...messages.q4PopUp1} />,
          <FormattedMessage {...messages.q4PopUp2} />,
          <FormattedMessage {...messages.q4PopUp3} />,
          <FormattedMessage {...messages.q4PopUp4} />,
        ],
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q5',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q5',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q5',
        },
      ],
    },
    {
      id: 'q5',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q5Title} />,
      imageSrc: 'images/question5-new.png',
      popUp: {
        popUpText: <FormattedMessage {...messages.q5PopUp} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q6',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q6',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q6',
        },
      ],
    },
    {
      id: 'q6',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q6Title} />,
      imageSrc: 'images/question6-new.png',
      popUp: {
        popUpText: <FormattedMessage {...messages.q6PopUp} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q7',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q7',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q7',
        },
      ],
    },
    {
      id: 'q7',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q7Title} />,
      imageSrc: 'images/question7-new.png',
      popUp: {
        popUpText: <FormattedMessage {...messages.q7PopUp} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q8',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q8',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q8',
        },
      ],
    },
    {
      id: 'q8',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q8Title} />,
      imageSrc: 'images/question8-new.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q9',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q9',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q9',
        },
      ],
    },
    {
      id: 'q9',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q9Title} />,
      imageSrc: 'images/question9-new.png',
      popUp: {
        popUpText: <FormattedMessage {...messages.q9PopUp} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q10',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q10',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q10',
        },
      ],
    },
    {
      id: 'q10',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q10Title} />,
      imageSrc: 'images/question10-new.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'results',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'results',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'results',
        },
      ],
    },
  ],
  results: {
    resultsTitleGreen: <FormattedMessage {...messages.resultsTitleGreen} />,
    resultsSubtitleGreen: (
      <FormattedMessage {...messages.resultsSubtitleGreen} />
    ),
    resultsTitleYellow: <FormattedMessage {...messages.resultsTitleYellow} />,
    resultsSubtitleYellow: (
      <FormattedMessage {...messages.resultsSubtitleYellow} />
    ),
    resultsTitleRed: <FormattedMessage {...messages.resultsTitleRed} />,
    resultsSubtitleRed: <FormattedMessage {...messages.resultsSubtitleRed} />,
    resultsCopy: <FormattedMessage {...messages.resultsCopy} />,
    // next step
    nextStepTitle: <FormattedMessage {...messages.nextStepTitle} />,
    nextStepCopy: <FormattedMessage {...messages.nextStepCopy} />,
    nextStepCopyBold: <FormattedMessage {...messages.nextStepCopyBold} />,
    nextStepCopy2: <FormattedMessage {...messages.nextStepCopy2} />,
    nextStepCta: <FormattedMessage {...messages.nextStepCta} />,
    // talk to an expert
    expertsTitle: <FormattedMessage {...messages.expertsTitle} />,
    expertsCopy: <FormattedMessage {...messages.expertsCopy} />,
    expertsCta: <FormattedMessage {...messages.expertsCta} />,
    // stats
    statsTitle: <FormattedMessage {...messages.statsTitle} />,
    statsCopy: <FormattedMessage {...messages.statsCopy} />,
    statsCta: <FormattedMessage {...messages.statsCta} />,
    stats1: <FormattedMessage {...messages.stats1} />,
    stats2: <FormattedMessage {...messages.stats2} />,
    stats3: <FormattedMessage {...messages.stats3} />,
    stats4: <FormattedMessage {...messages.stats4} />,
    // footnotes
    footnote1Link: <FormattedMessage {...messages.footnote1Link} />,
    footnote1: <FormattedMessage {...messages.footnote1} />,
    footnote2Link: <FormattedMessage {...messages.footnote2Link} />,
    footnote2: <FormattedMessage {...messages.footnote2} />,
  },
};
